import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

export class Mp4Layout extends Component {
  constructor(props) {
    super(props)
  }
  // TODO: link hardcoded
  videoLink = 'https://d3txy5owctt379.cloudfront.net/1700460473531/48097dc0-93fb-11ee-b6f8-df39334f6afb.mp4'
  // videoLink = 'https://d3txy5owctt379.cloudfront.net/1700460473531/9869b570-99bc-11ee-ad1e-fddf5720483f.mp4'
  render() {
    return (
      <div className={css(Styles.contentHolderFull,this.props.containerStyle)}>
        <video id='myVideo' className={css(Styles.video)} autoPlay muted>
          <source src={this.videoLink} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  contentHolderFull: {
    maxHeight: '100vh',
    overflow: 'hidden',
    width: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
    background: '#000',
    margin: 0,
    padding: 0
  },
  video: {
    width: '100%',
    height: '100%',
    maxHeight: '100vh'
  }
})



// WEBPACK FOOTER //
// ./src/screens/Mp4Layout.js